import { z } from 'zod';
export const TrainingStatus = z.enum(['in_progress', 'completed', 'skipped']);
export const trainingProgressEntry = z.object({
    lessonSlug: z.string().min(1).max(200),
    status: TrainingStatus,
    attempts: z.number().int().nonnegative(),
    completedAt: z.string().datetime().nullable(),
    lastActiveAt: z.string().datetime(),
});
export const trainingProgressResponse = z.object({
    items: z.array(trainingProgressEntry),
    completed: z.number().int().nonnegative(),
    inProgress: z.number().int().nonnegative(),
    skipped: z.number().int().nonnegative(),
});
export const updateTrainingProgressRequest = z.object({
    status: TrainingStatus,
});
/**
 * Server-seitige Erfüllungs-Prüfung pro Lektion (interaktive Übungen).
 * Backend bestätigt, ob die in der Lektion geforderte Aktion vollzogen wurde
 * (z.B. "Projekt mit Bundesland Bayern existiert").
 *
 * `requirement` ist ein dokumentierter String, den der Frontend-User sieht;
 * `met` ist das Boolean-Resultat.
 */
export const trainingCheckResponse = z.object({
    lessonSlug: z.string(),
    met: z.boolean(),
    requirement: z.string(),
    hint: z.string().optional(),
});
